import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../reducers/types";

import { PackagesFlightShop } from "./component";
import {
  getRewardsAccounts,
  getRewardsAccountWithLargestEarnForBanner,
} from "../rewards/reducer";
import { getIsFlightShopLoading } from "./reducer";
import {
  fetchPackagesFlightShop,
  setPackagesFlightShopProgress,
} from "./actions/actions";
import { getPackagesAvailabilityCallState } from "../availability/reducer";

const mapStateToProps = (state: IStoreState) => ({
  largestValueAccount: getRewardsAccountWithLargestEarnForBanner(state),
  isFlightShopLoading: getIsFlightShopLoading(state),
  packagesAvailabilityCallState: getPackagesAvailabilityCallState(state),

  rewardsAccounts: getRewardsAccounts(state),
});

export const mapDispatchToProps = {
  fetchPackagesFlightShop,
  setInternalPackagesFlightShopProgress: setPackagesFlightShopProgress,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PackagesFlightShopConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPackagesFlightShop = withRouter(
  connector(PackagesFlightShop)
);
